const moduleMap = {
	"./ModuleConfiguration": () => {
		return Promise.all([__webpack_require__.e(7814), __webpack_require__.e(9324), __webpack_require__.e(2632), __webpack_require__.e(9678), __webpack_require__.e(8646), __webpack_require__.e(9302), __webpack_require__.e(5931), __webpack_require__.e(6072), __webpack_require__.e(3887), __webpack_require__.e(2635), __webpack_require__.e(3601), __webpack_require__.e(9871), __webpack_require__.e(3982), __webpack_require__.e(846), __webpack_require__.e(2967), __webpack_require__.e(5384)]).then(() => (() => ((__webpack_require__(95483)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});